import { useEffect } from "react";
import {
  type BroadcastAction,
  CHANNEL_NAME,
} from "@/shared/services/broadcast/BroadcastActions.ts";

export default function useOnBroadcastAction(params: {
  onFrontendStateUpdated?: () => void;
  onBackendDataRefreshed?: (jscache: object) => void;
  onLogout?: () => void;
}): void {
  useEffect(() => {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = (e): void => {
      const action = e.data as BroadcastAction;
      switch (action.action) {
        case "frontendStateUpdated":
          params.onFrontendStateUpdated?.();
          break;
        case "backendDataRefreshed":
          params.onBackendDataRefreshed?.(action.payload);
          break;
        case "logout":
          params.onLogout?.();
          break;
      }
    };
    return (): void => {
      channel.close();
    };
  }, [params]);
}
